export default __webpack_public_path__ + "img/check-black.80a11afe.svg";